import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7 11h10v2H7v-2ZM4 7h16v2H4V7Zm6 8h4v2h-4v-2Z"
	})
});
export default SvgBxFilter;
